export default __webpack_public_path__ + "static/media/icon-cloud-upload-black.65cdb516.svg";